import { render, staticRenderFns } from "./SpaceFacilities.vue?vue&type=template&id=6b8d79d5&scoped=true"
import script from "./SpaceFacilities.vue?vue&type=script&lang=ts"
export * from "./SpaceFacilities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d79d5",
  null
  
)

export default component.exports